export default "__VITE_ASSET__CDs7ZFc0__"